import { useEffect } from 'react';

export const useModalOverflow = (open?: boolean) => {
    useEffect(() => {
        if (open) document.body.style.overflow = 'hidden';
        else document.body.style.removeProperty('overflow');

        return () => {
            document.body.style.removeProperty('overflow');
        };
    }, [open]);
};
